import { CardRec } from '@/components/common/Card'
import { LinkRoute } from '@/components/common/Link'
import { type RecType } from '@/defs/rec'
import { type StatType } from '@/defs/stat'

import styles from './PreconCard.module.scss'

type Props = {
  href?: string
  image?: string
  label?: string
  rec: RecType
  stats?: StatType[]
}

export const PreconCard = ({ href, image, label, rec, stats }: Props) => {
  const imgElement = (
    <img alt={`Image of the ${label || 'Unknown'} sealed product`} decoding='async' loading='lazy' src={image} />
  )

  return (
    <div className={styles.container}>
      {!!image && (
        <div className={styles.imageWrap}>{href ? <LinkRoute href={href}>{imgElement}</LinkRoute> : imgElement}</div>
      )}
      <div className={styles.cardWrap}>
        <CardRec disableModal href={href} rec={rec} stats={stats} />
      </div>
    </div>
  )
}
